import {Component} from 'react'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'

import {loadCategories, loadTags} from '../../components/Blog/actions.js'
import Categories from '../../components/Blog/Sidebar/Categories/Categories.jsx'
import Tags from '../../components/Blog/Sidebar/Tags/Tags.jsx'
import ArticlesList from '../../components/Blog/ArticlesList.jsx'
import ArticlesSidebarCard from '../../components/Blog/Sidebar/ArticleCard/ArticleCard.jsx'

import './Sidebar.scss'

class Sidebar extends Component {
  static propTypes = {
    className: PropTypes.string,
    articles: PropTypes.array
  }

  static defaultProps = {
    className: '',
    articles: []
  }

  componentDidMount() {
    this.props.loadCategories()
    this.props.loadTags()
  }

  render() {
    return (
      <div className={`blog-sidebar ${this.props.className}`}>
        <Categories categories={this.props.categories}/>
        <Tags tags={this.props.tags}/>
        <div className="d-none d-md-block">
          <ArticlesList
            articles={this.props.articles}
            card={ArticlesSidebarCard}
            flex={false}
          >
            <h3>Derniers articles</h3>
          </ArticlesList>
        </div>
      </div>
    )
  }
}

export default connect(
  state => ({
    categories: state.blog.categories,
    tags: state.blog.tags
  }),
  dispatch => ({
    loadCategories: () => dispatch(loadCategories()),
    loadTags: () => dispatch(loadTags()),
  })
)(Sidebar)